export default __webpack_public_path__ + "static/media/fontainebleau7.c1564ddb.jpg";